// 知识管理
const Knowledge = () => import('@/pages/knowledge/index.vue');

const arr = [
  // 知识管理
  {
    path: '/knowledge',
    name: 'knowledge',
    component: Knowledge,
    meta: {
      auth: false,
    },
  },
];

export default arr;
